import {Component, Input, OnInit, ViewChild} from "@angular/core";
import {JsonEditorComponent, JsonEditorOptions} from "ang-jsoneditor";
import {HttpHeaders} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {ConfService} from "../../../conf.service";
import {ConnecttocrudService} from "../../../connecttocrud.service";
import {ActivatedRoute} from "@angular/router";

declare let $;
@Component({
    selector: 'method-get',
    templateUrl: './api-executor.component.html',
    styleUrls: ['./api-executor.component.css']
})
export class ApiExecutorComponent implements OnInit{
    requestBodySelected = 'none';
    response: any;
    getResponse: any;
    getRequest: any;
    getHttpOptions: any;
    putResponse: any;
    putRequest: any;
    putHttpOptions: any;
    dataModelPost: any;
    dataModelPut: any;
    postResponse: any;
    postRequest: any;
    postHttpOptions: any;
    dataSource: any;
    deleteResponse: any;
    deleteRequest: any;
    deleteHttpOptions: any;
    partnerKey: string;
    dataModel: any;
    entity: string;
    version: string;
    @Input() operations: any;
    @Input() parameterData: any;
    @Input() headersData: any;
    @Input() authModel: any;
    @Input() requestBody: any;
    @Input() prerequisites: any;
    @Input() description_flag: boolean;
    // @Input() operations: any;
    @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
    options1 = new JsonEditorOptions();
    constructor(private _service: ConnecttocrudService, private confPost: ConfService,
                private route: ActivatedRoute){
        this.options1.mode = 'code';
        this.options1.modes = ['code', 'text', 'tree', 'view'];
        this.options1.schema = '';
        this.options1.statusBar = false;
        this.options1.onChange = () => console.log(/* this.editor.get()*/);
    }
    ngOnInit(): void {
        this.partnerKey = localStorage.getItem('partnerKey');
        this.route.queryParams
            .subscribe(params => {
                this.entity = params.entity;
                this.version = params.version;
                this.getDevex();
            });

    }
    getDevex(){
        this.confPost.getPartnerEntity(localStorage.getItem('account'),
            this.entity, localStorage.getItem('partner')).subscribe(items => {
            this.dataSource = items[0].attributes;
            this.getDataModel();
        });
    }

    getParameterTableName(val) {
        if (val != null && val.length !== 0) {
            return val.toLowerCase() + 'OperationTable';
        }
        return 'OperationTable';
    }
    getHeaderTableName(val) {
        if (val != null && val.length !== 0) {
            return val.toLowerCase() + 'HeaderTable';
        }
        return 'HeaderTable';
    }

    getRequestBody() {
        const requestbody = {
            'type': this.requestBodySelected,
            'value': this.getRequestBodyValue(this.requestBodySelected)
        };
        return requestbody;
    }
    getRequestBodyValue(val) {
        switch (val) {
            case 'raw':
                return this.editor.get();

            case '' +
            'binary':
            case 'none':
            default:
        }
    }
    stringifyjson(val) {
        if (val != null) {
            return JSON.stringify(val, null, 2).trim();
        } else {
            return val;
        }
    }
    print(val) {
        if (val != null) {
            return val.trim();
        }
        return val;
    }

    getHeaders(type) {
        const headers = [];
        switch (type.toLowerCase()) {
            case 'get':
                $('#getHeaderTable').children('tbody').children('tr').each(function () {
                    const header = {};
                    header['key'] = $(this).find('td:first').find('input').val();
                    header['value'] = $(this).find('td:eq(1)').find('input').val();
                    headers.push(header);
                });
                return headers;
            case 'put':
                $('#putHeaderTable').children('tbody').children('tr').each(function () {
                    const header = {};
                    header['key'] = $(this).find('td:first').find('input').val();
                    header['value'] = $(this).find('td:eq(1)').find('input').val();
                    headers.push(header);
                });
                return headers;
            case 'post':
                $('#postHeaderTable').children('tbody').children('tr').each(function () {
                    const header = {};
                    header['key'] = $(this).find('td:first').find('input').val();
                    header['value'] = $(this).find('td:eq(1)').find('input').val();
                    headers.push(header);
                });
                return headers;
            case 'delete':
                $('#deleteHeaderTable').children('tbody').children('tr').each(function () {
                    const header = {};
                    header['key'] = $(this).find('td:first').find('input').val();
                    header['value'] = $(this).find('td:eq(1)').find('input').val();
                    headers.push(header);
                });
                return headers;
            default:
                break;
        }
    }

    getParameters(type) {
        const parameters = [];
        switch (type.toLowerCase()) {
            case 'get':
                $('#getOperationTable').children('tbody').children('tr').each(function () {
                    const parameter = {};
                    if ($('#GETquery').val()) {
                        parameter['key'] = $(this).find('td:first').find('b').find('mat-label').text();
                        parameter['value'] = $(this).find('td:eq(1)').find('input').val();
                        parameters.push(parameter);
                    }
                });
                return parameters;
            case 'put':
                $('#putOperationTable').children('tbody').children('tr').each(function () {
                    const parameter = {};
                    parameter['key'] = $(this).find('td:first').find('input').val();
                    parameter['value'] = $(this).find('td:eq(1)').find('input').val();
                    parameters.push(parameter);
                });
                return parameters;
            case 'post':
                $('#postOperationTable').children('tbody').children('tr').each(function () {
                    const parameter = {};
                    parameter['key'] = $(this).find('td:first').find('input').val();
                    parameter['value'] = $(this).find('td:eq(1)').find('input').val();
                    parameters.push(parameter);
                });
                return parameters;
            case 'delete':
                $('#deleteOperationTable').children('tbody').children('tr').each(function () {
                    const parameter = {};
                    parameter['key'] = $(this).find('td:first').find('input').val();
                    parameter['value'] = $(this).find('td:eq(1)').find('input').val();
                    parameters.push(parameter);
                });
                return parameters;
            default:
                break;
        }
    }

    executeApi(type, url) {
        const headers = {};
        $('#headersTable').children('tbody').children('tr').each(function () {
            headers[$(this).find('td:first').find('input').val()] = $(this).find('td:eq(1)').find('input').val();
        });
        if (!url.startsWith('http')) {
            if (url.startsWith('/')){
                url = environment.apihost + url;
            } else {
                url = environment.apihost + '/' + url;
            }

        }
        const payload = {
            'executor_name': '',
            'executor_type': 'API',
            'executor_method_type': type,
            'apiUrl': url,
            'dataroot': null,
            'queryParams': this.getParameters(type),
            'headers': this.getHeaders(type),
            'authModel': null,
            'requestBody': this.getRequestBody(),
            'prerequisites': null
        };

        this._service.executeApi(payload).subscribe(response => {
            this.getResponse = response;
            this.getRequest = payload;
        });
    }

    TestEndpoints(type, url, pkey) {

        const httpOptions1 = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': pkey,
                'Access-Control-Allow-Origin': '*'
            })
        };

        if (type === 'GET') {
            this.getHttpOptions = httpOptions1;
            if ($('#GETdatabase').val() != null && $('#GETdatabase').val().length !== 0 && $('#GETquery').val() != null && $('#GETquery').val().length !== 0) {
                url += '?' + 'database=' + $('#GETdatabase').val() + '&' + 'query=' + $('#GETquery').val();
            } else {
                if ($('#GETdatabase').val() != null && $('#GETdatabase').val().length !== 0) {
                    url += '?' + 'database=' + $('#GETdatabase').val();
                }
                if ($('#GETquery').val() != null && $('#GETquery').val().length !== 0) {
                    url += '?' + 'query=' + $('#GETquery').val();
                }
            }
            this.getRequest = environment.apihost + '/' + url;
            this._service.getItemsForUrl(url, this.getHttpOptions).subscribe(items => {
                this.getResponse = items;
            });
        } else if (type === 'PUT') {
            this.putHttpOptions = httpOptions1;
            const newUrl = url.replace(/:id/gi, $('#PUTid').val());
            this.putRequest = environment.apihost + '/' + newUrl;

            this.postHttpOptions = httpOptions1;
            this.postRequest = environment.apihost + '/' + url;

            const data = this.editor.get();
            data['id'] = this.dataSource.id;
            this._service.putItemForUrl(newUrl, this.putHttpOptions, data).subscribe(items => {
                this.putResponse = items;
            });
        } else if (type === 'POST') {

            this.postHttpOptions = httpOptions1;
            this.postRequest = environment.apihost + '/' + url;
            const data = this.editor.get();
            data['id'] = this.dataSource.id;

            this._service.postItemForUrl(url, this.postHttpOptions, data).subscribe(items => {
                this.postResponse = items;
            });
        } else if (type === 'DELETE') {
            this.deleteHttpOptions = httpOptions1;
            const newUrl = url.replace(/:id/gi, $('#DELETEid').val());
            this.deleteRequest = environment.apihost + '/' + newUrl;
            this._service.deleteItemForUrl(newUrl, this.deleteHttpOptions).subscribe(items => {
                this.deleteResponse = items;
            });
        } else {

        }
    }
    getData(one, two, three) {
        const data = {
            "type": one,
            "url": two,
            "pkey": three
        }
        return data;
    }
    getDataModel() {
        this.dataModel = {};
        const that = this;
        this.dataSource.forEach((data) => {
            if (data.type != 'Array') {
                this.dataModel[data.attributeName] = data.type;
            } else {
                this.dataModel[data.attributeName] = (that.getSub(data.subType).length > 0 ? that.getSub(data.subType) : []);
            }
        });
        this.dataModelPut = this.dataModel;
        this.dataModelPost = this.dataModel;
        return this.dataModel;
    }
    getSub(data) {
        const subType = [];
        const obj = {};
        const that = this;
        if (data.length > 0) {
            data.forEach((result) => {
                if (result.type != 'Array') {
                    obj[result.attributeName] = result.type;
                } else {
                    obj[result.attributeName] = (that.getSub(result.subType).length > 0 ? that.getSub(result.subType) : []);
                }
            });
            subType.push(obj);
        }
        return subType;
    }
}
